// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_style_wrapper__2RHwl","icon":"Icon_style_icon__1Vc2W","text":"Icon_style_text__Glvz_"};